import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Icon, UilChartPie } from '@iconscout/react-unicons';

export interface Route {
  name: string;
  icon?: IconProp | string | string[];
  iconSet?: 'font-awesome' | 'feather' | 'unicons';
  pages?: Route[];
  path?: string;
  pathName?: string;
  flat?: boolean;
  topNavIcon?: string;
  dropdownInside?: boolean;
  active?: boolean;
  new?: boolean;
  hasNew?: boolean;
}

export interface RouteItems {
  label: string;
  horizontalNavLabel?: string;
  icon: Icon;
  labelDisabled?: boolean;
  pages: Route[];
  megaMenu?: boolean;
  active?: boolean;
}

export const superadminsitemap: RouteItems[] = [
  {
    label: 'dashboard',
    horizontalNavLabel: 'home',
    active: true,
    icon: UilChartPie,
    labelDisabled: true,
    pages: [
      {
        name: 'Clinics',
        path: '/superadmin/clinic/list',
        pathName: 'clinic/list',
        topNavIcon: 'phone',
        active: true
      },
      {
        name: 'Food Database',
        path: '/superadmin/food/list',
        pathName: 'food/list',
        active: true
      },
      {
        name: 'Import Foods',
        path: '/superadmin/food/import',
        pathName: 'food/import',

        active: true
      }
    ]
  }
];
